/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { Component } from 'react';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import noop from 'lodash/noop';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import {
	AnalyticsSource,
	type ContextResult,
} from '@jira/platform__analytics-web-react/src/components/decorators.tsx';
import { Provider as ReduxProvider } from '@atlassian/jira-react-redux/src/index.tsx';
import AppStyle from '@jira/platform__app-style/src/index.tsx';
import { MODAL } from '@atlassian/jira-product-analytics-bridge';
import type { Props } from './model/index.tsx';
import rootEpic from './ops/index.tsx';
import { setAppProps, getAssociatedItems } from './state/actions.tsx';
import createStore from './state/index.tsx';
import type { State } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line jira/react/no-class-components
class DeleteModal extends Component<Props> {
	static defaultProps: {
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		onInitialised: (...args: any[]) => void;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		onFilterDeleted: (...args: any[]) => void;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		onCancel: (...args: any[]) => void;
	} = {
		onInitialised: noop,
		onFilterDeleted: noop,
		onCancel: noop,
	};

	constructor(props: Props) {
		super(props);

		this.store = createStore(rootEpic);
		this.store.dispatch(setAppProps(this.props));
		this.store.dispatch(getAssociatedItems());
	}

	store: Store<State>;

	render(): React.JSX.Element {
		return (
			<ReduxProvider store={this.store}>
				<ReportErrors id="unhandled" packageName="jiraDeleteFiltersModal" teamName="jira-cosmos">
					<AppStyle>
						<View />
					</AppStyle>
				</ReportErrors>
			</ReduxProvider>
		);
	}
}

const DeleteFiltersModal: ContextResult<typeof DeleteModal, Props> = AnalyticsSource(
	'deleteFilter',
	MODAL,
)(DeleteModal);
export default DeleteFiltersModal;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { useDeleteChangeActions } from './controllers/delete-change-actions';
